import { render, staticRenderFns } from "./WatchAdGetRewardsRule.vue?vue&type=template&id=71d76e66&scoped=true"
import script from "./WatchAdGetRewardsRule.vue?vue&type=script&lang=js"
export * from "./WatchAdGetRewardsRule.vue?vue&type=script&lang=js"
import style0 from "./WatchAdGetRewardsRule.vue?vue&type=style&index=0&id=71d76e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d76e66",
  null
  
)

export default component.exports